import axios from "axios";
import { useRouter } from "next/navigation";
import { useCallback, useMemo } from "react";
import { toast } from "react-hot-toast";

import { SafeUser, SafeDiver } from "@/app/types";

import useLoginModal from "./useLoginModal";

interface IUseFavorite {
  listingId: string;
  currentUser?: SafeUser | null;
}

const useFavorite = ({ listingId, currentUser }: IUseFavorite) => {
  const router = useRouter();

  const loginModal = useLoginModal();

  const hasFavorited = useMemo(() => {
    // const list = currentUser?.favoriteIds || [];
    // const list = (currentUser as SafeUser & { diver?: SafeDiver }).diver?.[0]?.favoriteIds || []; // Accedemos al campo favoriteIds a través de diver

    // return list.includes(listingId);

    const favoriteIds = currentUser?.diver?.favoriteIds ?? [];
    return favoriteIds.includes(listingId);
  }, [currentUser, listingId]);

  const toggleFavorite = useCallback(async (e: React.MouseEvent<HTMLDivElement>) => {
    e.stopPropagation();

    if (!currentUser) {
      return loginModal.onOpen();
    }

    try {
      let request;

      if (hasFavorited) {
        request = () => axios.delete(`/api/favorites/${listingId}`);
        toast.success('Favorite removed');
      } else {
        request = () => axios.post(`/api/favorites/${listingId}`);
        toast.success('Favorite added');
      }

      await request();
      router.refresh();
    } catch (error) {
      toast.error('Something went wrong.');
    }
  }, 
  [
    currentUser, 
    hasFavorited, 
    listingId, 
    loginModal,
    router
  ]);

  return {
    hasFavorited,
    toggleFavorite,
  }
}

export default useFavorite;